<template>
  <div class="home">
    <div class="home-header">
      <h1 class="home-header-title">for all Larnaca Airport Transfers call</h1>
      <a href="tel:+35796090967" class="home-header-phone">+357-96090967</a>
    </div>
    <div class="cars-wrapper">
      <h1 class="title-black">Car types</h1>
      <div class="cars">
        <div class="car">
          <div class="car-img-wrapper">
            <img class="car-img" src="../assets/img/car_black.png" alt="Car">
          </div>
          <div class="car-specs">
            <span>from &euro;38</span>
          </div>
          <router-link class="car-learn" to="/cars">Learn more</router-link>
        </div>
        <div class="car">
          <div class="car-img-wrapper">
            <img class="car-img" src="../assets/img/van_black.png" alt="Van">
          </div>
          <div class="car-specs">
            <span>from &euro;49</span>
          </div>
          <router-link class="car-learn" to="/cars">Learn more</router-link>
        </div>
      </div>
    </div>
    <p class="p-center">* We have a baby seat infant booster and it can be used if needed.</p>
    <div class="gallery">
      <div
        class="gallery-item gallery-item-1"
        :class="{ 'gallery-item-active' : item === 1}"
        key="1"
        alt="Gallery Image"
      ></div>
      <div
        class="gallery-item gallery-item-2"
        :class="{ 'gallery-item-active' : item === 2}"
        key="2"
        alt="Gallery Image"
      ></div>
      <div
        class="gallery-item gallery-item-3"
        :class="{ 'gallery-item-active' : item === 3}"
        key="3"
        alt="Gallery Image"
      ></div>
      <div
        class="gallery-item gallery-item-4"
        :class="{ 'gallery-item-active' : item === 4}"
        key="4"
        alt="Gallery Image"
      ></div>
      <div
        class="gallery-item gallery-item-5"
        :class="{ 'gallery-item-active' : item === 5}"
        key="5"
        alt="Gallery Image"
      ></div>
      <div
        class="gallery-item gallery-item-6"
        :class="{ 'gallery-item-active' : item === 6}"
        key="6"
        alt="Gallery Image"
      ></div>
      <div
        class="gallery-item gallery-item-7"
        :class="{ 'gallery-item-active' : item === 7}"
        key="7"
        alt="Gallery Image"
      ></div>
      <div
        class="gallery-item gallery-item-8"
        :class="{ 'gallery-item-active' : item === 8}"
        key="8"
        alt="Gallery Image"
      ></div>
      <div
        class="gallery-item gallery-item-9"
        :class="{ 'gallery-item-active' : item === 9}"
        key="9"
        alt="Gallery Image"
      ></div>
      <div
        class="gallery-item gallery-item-10"
        :class="{ 'gallery-item-active' : item === 10}"
        key="10"
        alt="Gallery Image"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      speed: 5000,
      item: 1
    };
  },
  mounted() {
    setInterval(() => {
      if (this.item < 10) {
        this.item++;
      } else {
        this.item = 1;
      }
    }, this.speed);
  }
};
</script>

<style scoped>
.home-header {
  align-items: center;
  background-image: url("../assets/img/cover_darkest.jpg");
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  width: 100%;
}
.home-header-title {
  color: #fff;
  margin: 0;
}
.home-header-phone {
  color: #fff;
  font-size: 60px;
  font-weight: 700;
}
.home-header-phone:hover {
  color: #fdd55b;
  /* color: #ffec17; */
}
/* CARS */
.cars-wrapper {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  padding: 50px 20px 25px;
  width: 1000px;
}
.cars {
  display: flex;
}
.car {
  margin: 0 15px;
  width: 260px;
}
.car-img-wrapper {
  align-items: flex-end;
  display: flex;
  height: 100px;
  margin-bottom: 10px;
  width: 100%;
}
.car-img {
  width: 100%;
}
.car-specs {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  border-radius: 6px;
  display: flex;
  height: 50px;
  justify-content: center;
  padding: 0 20px;
}
.car-learn {
  align-items: center;
  background-color: #fdd55b;
  border-radius: 6px;
  display: flex;
  height: 50px;
  justify-content: center;
  margin-top: 10px;
  width: 100%;
}
.car-learn:hover {
  opacity: 0.9;
}
.p-center {
  padding: 0 20px;
  text-align: center;
  width: 100%;
}
/* GALLERY */
.gallery {
  border-radius: 6px;
  height: 40vw;
  margin: 30px auto;
  overflow: hidden;
  position: relative;
  width: 80vw;
}
.gallery-item {
  background-size: cover;
  background-position: center;
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  -webkit-transition: all 0.6s;
  -moz-transition: all 0.6s;
  -ms-transition: all 0.6s;
  -o-transition: all 0.6s;
  transition: all 0.6s;
  width: 100%;
}
.gallery-item-active {
  opacity: 1;
}
.gallery-item-1 {
  background-image: url("../assets/img/gallery/1.jpg");
}
.gallery-item-2 {
  background-image: url("../assets/img/gallery/2.jpg");
}
.gallery-item-3 {
  background-image: url("../assets/img/gallery/3.jpg");
}
.gallery-item-4 {
  background-image: url("../assets/img/gallery/4.jpg");
}
.gallery-item-5 {
  background-image: url("../assets/img/gallery/5.jpg");
}
.gallery-item-6 {
  background-image: url("../assets/img/gallery/6.jpg");
}
.gallery-item-7 {
  background-image: url("../assets/img/gallery/7.jpg");
}
.gallery-item-8 {
  background-image: url("../assets/img/gallery/8.jpg");
}
.gallery-item-9 {
  background-image: url("../assets/img/gallery/9.jpg");
}
.gallery-item-10 {
  background-image: url("../assets/img/gallery/10.jpg");
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
@media screen and (max-width: 1000px) {
  .cars-wrapper {
    width: 100%;
  }
}
@media screen and (max-width: 800px) {
  .cars {
    flex-direction: column;
  }
  .car {
    margin: 20px 15px;
  }
  .home-header-title {
    font-size: 20px;
    margin-bottom: 4px;
    text-align: center;
    padding: 0 20px;
    width: 100%;
  }
  .home-header-phone {
    font-size: 24px;
    text-align: center;
    padding: 0 20px;
    width: 100%;
  }
  .cars-wrapper {
    padding: 20px 20px 0;
  }
  .gallery {
    height: 50vw;
    margin: 20px auto;
    width: calc(100vw - 40px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue